//#region src/schema/helpers/schema-composition.ts
var e = [
	"oneOf",
	"anyOf",
	"allOf",
	"not"
];
//#endregion
export { e as compositions };

//# sourceMappingURL=schema-composition.js.map